/**
 * PersonalizedQuestionsPending.tsx - The placeholder shown while follow-up chips are generating
 *
 * This replaced a block of five skeleton chips. The skeleton was dishonest in two ways: it
 * promised five chips when the endpoint only ever serves two, and its shape said "this is
 * arriving imminently" when the work behind it is a model call the server budgets ten seconds
 * for. Five grey bars sitting still for that long reads as broken, not as loading.
 *
 * One pill that says what is happening survives a long wait, because it never made a promise
 * about size or speed in the first place. It is shaped like a real chip so the swap costs
 * roughly one row of layout rather than a whole block.
 *
 * It is rendered on a delay by SuggestionsPanel — see PENDING_VISIBLE_AFTER_MS there — so the
 * common fast paths (a cached set, or a new user the server answers immediately with no
 * history) never flash it.
 */

import { Flex, HStack, Text } from '@chakra-ui/react';
import { LuSparkles } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';

export const PersonalizedQuestionsPending: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Flex className="fadeLong" width="100%" justifyContent="center">
            <HStack
                className="suggestions-pending"
                gap={2}
                paddingX={{ base: 3, md: 4 }}
                paddingY={{ base: 2, md: 2.5 }}
                borderRadius="var(--cair-radius-lg)"
                borderWidth="1px"
                borderColor="var(--cair-border)"
                background="var(--cair-surface-elevated)"
                color="var(--cair-text-secondary)"
                maxWidth="100%"
            >
                <LuSparkles size={14} />
                <Text fontSize={{ base: 'xs', md: 'sm' }} fontWeight="medium" lineHeight="1.3">
                    {t('personalized_questions_pending')}
                </Text>
            </HStack>
        </Flex>
    );
};
